<div class="home-view">
  @for (col of columns(); let ci = $index; track ci) {
    <div class="home-column"
         id="home-col-{{ci}}"
         cdkDropList
         [cdkDropListData]="columns()[ci]"
         [cdkDropListConnectedTo]="connectedLists()"
         (cdkDropListDropped)="drop($event, ci)">

      @for (widget of col; track widget) {
        @switch (widget) {
          @case ('widget-warnings') { @if (showWarningsWidget()) { <app-warnings-widget></app-warnings-widget> } }
          @case ('widget-punctuality') { @if (showPunctualityWidget()) { <app-punctuality-widget></app-punctuality-widget> } }
          @case ('widget-late-departures') { @if (showLateDeparturesWidget()) { <app-late-departures-widget></app-late-departures-widget> } }
          @case ('widget-early-departures') { @if (showEarlyDeparturesWidget()) { <app-early-departures-widget></app-early-departures-widget> } }
          @case ('widget-ev-soc') { @if (showEvSocWidget()) { <app-ev-soc-widget></app-ev-soc-widget> } }
        }
      }

    </div>
    @if (ci < columns().length) {
      <div class="col-resize-handle"
           [style.height.px]="colContentHeights()[ci]"
           (mousedown)="onColumnResizeStart($event, ci)"></div>
    }
  }
</div>
